module.exports = __webpack_public_path__ + "static/Apercu-Italic-1812359d95712fd79c7b180c86faa74b.woff";